import { render, staticRenderFns } from "./AreaCreate.vue?vue&type=template&id=6ef7ba77&"
import script from "./AreaCreate.vue?vue&type=script&lang=ts&"
export * from "./AreaCreate.vue?vue&type=script&lang=ts&"
import style0 from "./AreaCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports